import React, { useRef } from 'react'
import { components, constants } from 'cng-web-lib'
import ACEHighwayInbond7512TranslationText from '../contexts/ACEHighwayInbond7512TranslationText'
import BillOfLadingFormProperties from './BillOfLadingFormProperties'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'

const {
  button: { CngPrimaryButton },
  form: { CngForm },
  CngDialog
} = components

const { FormState } = constants

function BillOfLadingDialog(props) {
  const { open, onClose, bol, ftz, entryType, mot, showNotification } = props
  const { initialValues, makeValidationSchema } =
    BillOfLadingFormProperties.formikProps

  const lastIndex = useRef(0)
  const {
    getValues,
    setValue,
    formState: { isSubmitting }
  } = useFormContext()


  const translatedTextsObject = ACEHighwayInbond7512TranslationText()

  function preSubmit(bol, data) {
    const bolContainer = data.bolContainer
    const additionalBOLIndicator = data.additionalBOLIndicator
    const containerizedIndicator = data.containerizedIndicator

    console.log("Container count: " + bolContainer.length)
    console.log("Additional BOL indicator: " + additionalBOLIndicator)
    console.log("Containerized indicator: " + containerizedIndicator)

    if (additionalBOLIndicator && (!containerizedIndicator || bolContainer.length == 0)) {
      showNotification('error', translatedTextsObject.bolContainerRequired)
      return
    }

    if (bol) {
      handleEditBol(data)
    } else {
      handleAddBol(data)
    }
  }

  function handleAddBol(data) {
    const bol = [...getValues('bol'), data].map(
      (b) => ({ ...b, _id: ++lastIndex.current })
    )

    setValue('bol', bol)
    onClose()
  }

  function handleEditBol(data) {
    const bol = [...getValues('bol')]
    const index = bol.findIndex((b) =>
      b.id ? b.id === data.id : b._id === data._id
    )

    bol[index] = data

    setValue('bol', bol, { shouldValidate: true })
    onClose()
  }

  return (
    <CngDialog
      dialogContent={
        <CngForm
          fieldLevel='form'
          formikProps={{
            initialValues: bol || initialValues,
            makeValidationSchema: makeValidationSchema,
            onSubmit: (data) => {
              preSubmit(bol, data)
            }
          }}
          formState={FormState.COMPLETED}
          innerForm={true}
          renderBodySection={(labelMap, shouldHideMap) => (
            <BillOfLadingFormProperties.Fields
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
              ftz={ftz}
              entryType={entryType}
              mot={mot}
            />
          )}
          renderButtonSection={() => (
            <Box display='flex' justifyContent='flex-end'>
              <CngPrimaryButton type='submit' disabled={isSubmitting}>
                {bol
                  ? translatedTextsObject.updateButton
                  : translatedTextsObject.saveButton}
              </CngPrimaryButton>
            </Box>
          )}
        />
      }
      dialogTitle={translatedTextsObject.bolTitle}
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      fullWidth
      maxWidth='lg'
      onClose={onClose}
      open={open}
      shouldShowCloseButton
    />
  )
}

export default BillOfLadingDialog
